export enum RLV_CHOICE {
  LEISTUNGSVERLAUF = 'leistungsverlauf',
}
